export default "__VITE_ASSET__DulKyhmk__"